document.addEventListener('DOMContentLoaded', function () {
  const upsellBtns = document.querySelectorAll('[data-upsell-btn]');

  upsellBtns.forEach((button) => {
    button.addEventListener('click', function (e) {
      const variantId = this.getAttribute('data-variant-id');
      const quantity = this.getAttribute('data-quantity');

      if (variantId && quantity) {
        const upsellItems = [
          {
            id: variantId,
            quantity: parseInt(quantity, 10),
          },
        ];

        if (upsellItems) {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ items: upsellItems }),
          })
            .then((response) => response.json())
            .then((data) => {
              updateAddToCartPage(variantId, data);
            })
            .catch((error) => {
              console.error('Error:', error);
            });
        }
      }
    });
  });
});

function updateAddToCartPage(variantId, data) {
  const cartCountWrapper = document.querySelector('.cart-count');
  const variantElements = document.querySelectorAll(`[data-upsell="${variantId}"]`);
  const variantAddBtn = document.querySelector(`[data-upsell-add-btn="${variantId}"]`);
  const variantBtn = document.querySelector(`[data-upsell-btn="${variantId}"]`);
  const opacityClass = 'opacity-50';

  const variantTitle = data.items[0].title;
  const variantImage = data.items[0].image;
  const notificationTitle = document.querySelector('[data-upsell-title]');
  const notificationImage = document.querySelector('[data-upsell-image]');

  fetchCartItemCount().then((itemCount) => {
    if (itemCount !== null) {
      // Update the cart count bubble
      cartCountWrapper.textContent = itemCount;

      // Update the productcard
      variantElements.forEach((element) => {
        element.classList.add(opacityClass);

        if (variantBtn.classList.contains('btn')) {
          variantBtn.classList.add('hidden');
          variantBtn.classList.remove('btn');
        }

        if (variantAddBtn.classList.contains('hidden')) {
          variantAddBtn.classList.add('btn');
          variantAddBtn.classList.remove('hidden');
        }
      });

      // Update the notification banner
      notificationTitle.textContent = variantTitle;
      notificationImage.src = variantImage;
    }
  });
}

async function fetchCartItemCount() {
  try {
    const response = await fetch('/cart.json', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data.item_count;
  } catch (error) {
    return null;
  }
}
